var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.305,
    height: 20.102,
    viewBox: "0 0 15.305 20.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_spreadsheet-file_966221_000000",
    d: "M30.558,9.462,26.252,5.179A.71.71,0,0,0,25.806,5H16.882A1.19,1.19,0,0,0,15.7,6.183V23.919A1.19,1.19,0,0,0,16.882,25.1h12.94A1.19,1.19,0,0,0,31,23.919V10.578a1.606,1.606,0,0,0-.446-1.115Zm-.714.558h-3.57a.3.3,0,0,1-.29-.29V6.16ZM29.822,24.3H16.882a.4.4,0,0,1-.4-.4V6.183a.4.4,0,0,1,.4-.4h8.343V9.752A1.047,1.047,0,0,0,26.274,10.8h3.949V23.919a.4.4,0,0,1-.4.379ZM18.4,14.459a.258.258,0,0,0-.268.268v7.583a.258.258,0,0,0,.268.268h9.95a.258.258,0,0,0,.268-.268V14.727a.258.258,0,0,0-.268-.268Zm7.7,1.9H24.579V14.928H26.1Zm0,1.9H24.579V16.824H26.1Zm0,1.9H24.579V18.721H26.1Zm-5.489-1.4h1.517v1.427H20.607Zm0-1.9h1.517v1.427H20.607Zm3.5,1.4H22.593V16.824H24.11Zm-1.516.492h1.517v1.427H22.593Zm1.516-2.388H22.593V14.928H24.11Zm-1.985,0H20.607V14.928h1.517Zm-3.5-1.4h1.517v1.427H18.622Zm0,1.9h1.517v1.427H18.622Zm0,1.9h1.517v1.427H18.622Zm0,3.3V20.617h1.517v1.427Zm1.985,0V20.617h1.517v1.427Zm1.986,0V20.617h1.517v1.427Zm1.985,0V20.617H26.1v1.427Zm3.5,0H26.564V20.617h1.517Zm0-1.9H26.564V18.721h1.517Zm0-1.9H26.564V16.824h1.517Zm0-1.9H26.564V14.928h1.517Z",
    transform: "translate(-15.699 -5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreadsheet);
export default __webpack_public_path__ + "static/media/spreadsheet.d70cd8c2.svg";
export { ForwardRef as ReactComponent };